import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function House3Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6803 2.47516C14.2166 0.50828 17.7834 0.50828 20.3197 2.47516L28.3197 8.679C30.0094 9.9893 31 11.9964 31 14.1257V24.0781C31 27.9133 27.8536 31 24 31H8C4.14641 31 1 27.9133 1 24.0781V14.1257C1 11.9964 1.99061 9.9893 3.68026 8.679L11.6803 2.47516ZM10.5 22C9.9477 22 9.5 22.4477 9.5 23C9.5 23.5523 9.9477 24 10.5 24H21.5C22.0523 24 22.5 23.5523 22.5 23C22.5 22.4477 22.0523 22 21.5 22H10.5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
